
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ReportIcon from '@mui/icons-material/Report';
import HistoryIcon from '@mui/icons-material/History';
import Parkings from '../components/Parkings';
import AuthService from "../services/auth.service";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Moment from 'react-moment';
import moment from 'moment';
import 'moment/min/locales'

import authHeader from "../services/auth-header";
import { useTranslation } from "react-i18next";

const api = require("../api/names.js");



function ParkingList(props) {

  const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [currentUser, setCurrentUser] = useState(undefined);

    const [itemsAll, setItemsAll] = useState([]);
    const [itemsBusy, setItemsBusy] = useState([]);
    const [itemsWithWarning, setItemsWithWarning] = useState([]);
    const [itemsWithLowBattery, setItemsWithLowBattery] = useState([]);
    const [itemsNotBusy, setItemsNotBusy] = useState([]);


    const params = useParams();
    useEffect(() => {
      const user = AuthService.getCurrentUser();
      //alert(user.id);
      if (user) {
        setCurrentUser(user);
        //setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
        //setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
      }

      if(user.id == 4)
      {
        var url = api.baseUrl+'/parkings/';
        //url += user.id;//params.userID;//currentUser.id;//props.userID;
      }
      else {
        var url = api.baseUrl+'/parkings/byUserID/';
        url += user.id;//params.userID;//currentUser.id;//props.userID;
      }

      console.log(url);
      fetch(url, {
   method: 'get',
   headers: authHeader()
 })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          setIsLoaded(true);
          setItems(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )

      loadCurrentDataFromApi(user.id);

      const interval = setInterval(() => {
        loadCurrentDataFromApi(user.id);
      }, 5000);

    },[])

    function loadCurrentDataFromApi(user) {
      if(user == 4)
      {
        var url = api.baseUrl+'/detectorsCurrentValues/';
        //url += user.id;//params.userID;//currentUser.id;//props.userID;
      }
      else {
        var url = api.baseUrl + '/detectorsCurrentValues/byUserID/';
        url += user;//params.userID;//currentUser.id;//props.userID;
      }

      //console.log(url);
      fetch(url, {
   method: 'get',
   headers: authHeader()
 })
        .then(res => res.json())
        .then(
          (result) => {
            console.log(result);

            setItemsAll(result);
            setItemsBusy(result.filter(item => item.isBusy == 1));
            setItemsNotBusy(result.filter(item => item.isBusy == 0));
            setItemsWithWarning(result.filter(item => (item.timestamp / 1000) < (Math.round(moment().unix()) - 86400)));
            setItemsWithLowBattery(result.filter(item => (item.battery) < 100));
            setIsLoaded(true);

          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
    }

    if (error) {
      return <div>{t('detectord.error')}{error.message}</div>;
     } else if (!isLoaded) {
      return <div>{t('detectord.loading')}</div>;
     } else {
       return (

<div>
<Box sx={{ width: '100%' }}>

  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

    <Grid item xs={12} lg>
      {t('detectorsbp.allsensors')}{itemsAll.length}
    </Grid>
    <Grid item xs={12} sm={6} lg>
      {itemsNotBusy.length}{t('detectorsbp.free.2')}
    </Grid>
    <Grid item xs={12} sm={6} lg>
      {itemsBusy.length}{t('detectorsbp.busy.2')}
    </Grid>
    <Grid item xs={12} sm={6} lg>
      {Math.round((itemsNotBusy.length / itemsAll.length) * 100)}%{t('detectorsbp.free.2')}
    </Grid>
    <Grid item xs={12} sm={6} lg>
      {Math.round((itemsBusy.length / itemsAll.length) * 100)}%{t('detectorsbp.busy.2')}
    </Grid>
    <Grid item xs={12} sm={6} lg>
      {itemsWithWarning.length} {t('detectorsbp.notResponding')}
    </Grid>
    <Grid item xs={12} sm={6} lg>
      {itemsWithLowBattery.length} {t('detectorsbp.lowBattery')}
    </Grid>

  </Grid>
<Button href={'/parkingErrors'} variant="outlined" startIcon={<ReportIcon />}>{t('parkingerrors.button')}</Button>
{currentUser.id == 6 && <Button href={'/ledTables'} variant="outlined" startIcon={<ReportIcon />}>Tablica Informacji Parkingowych</Button>}
<Button href={'/parkingNew'} variant="outlined" startIcon={<ReportIcon />}>Parking New</Button>
</Box>
  <Parkings/>
  <TableContainer component={Paper}>
   <Table sx={{ minWidth: 650 }} aria-label="simple table">
     <TableHead>
        <TableRow>
        <TableCell>Nr</TableCell>
                   <TableCell>{t('charttable.name')}</TableCell>
                   <TableCell >{t('charttable.description')}</TableCell>
         <TableCell ></TableCell>
         <TableCell ></TableCell>
       </TableRow>
     </TableHead>
     <TableBody>
       {items.map(item => (
         <TableRow
           key={item.id}
           sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
         >
          <TableCell >{item.id}</TableCell>
           <TableCell >{item.parkingName}</TableCell>
           <TableCell >{item.description}</TableCell>
           <TableCell >
           <Button href={'/parkingDetails/' + item.id} sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} variant="outlined" startIcon={<DirectionsCarIcon />}>{t('parkinglist.current')}</Button>
           <Button href={'/parkingDetails/' + item.id} sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} variant="outlined" startIcon={<DirectionsCarIcon />}></Button>
           </TableCell>
           <TableCell >
           <Button href={'/parkingStats/' + item.id} sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} variant="outlined" startIcon={<HistoryIcon />}>{t('parkinglist.historical')}</Button>
           <Button href={'/parkingStats/' + item.id} sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} variant="outlined" startIcon={<HistoryIcon />}></Button>
           </TableCell>
         </TableRow>
       ))}
     </TableBody>
   </Table>
  </TableContainer>
  </div>





       );
     }
   }

export default ParkingList;
